// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__AkbXD","shimmer":"styles_shimmer__n0QqQ"};